// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.
import './Marketing.css';
import Footer from '../components/Footer';

const About = () => (
  <>
    <div className="about-page">
      <div className="about-hero">
        <p className="pill">About Servantica</p>
        <h1 className="about-title">Empowering your business with unified AI + communications</h1>
        <p className="about-lead">A single, secure workspace that blends messaging, voice, AI, and billing so teams can launch quickly and scale confidently.</p>
        <div className="about-cta-row">
          <a href="/login" className="marketing-cta">Get started</a>
          <a href="/pricing" className="marketing-cta secondary">See pricing</a>
        </div>
      </div>

      <div className="about-grid">
        <div className="about-card">
          <p className="about-label">AI Suite</p>
          <h3>Voice, vision, and speech</h3>
          <ul>
            <li>Speech ↔ Text conversions</li>
            <li>Face detection and image analysis</li>
            <li>Chat and voice assistants</li>
          </ul>
        </div>
        <div className="about-card">
          <p className="about-label">Communications</p>
          <h3>SMS and Calls with gating</h3>
          <ul>
            <li>Send and schedule SMS</li>
            <li>Calls with notes and scheduling</li>
            <li>Dashboard-ready UI components</li>
          </ul>
        </div>
        <div className="about-card">
          <p className="about-label">Billing & Security</p>
          <h3>Razorpay and Auth0 built-in</h3>
          <ul>
            <li>₹5 unlock flows per feature</li>
            <li>Email-aware subscription checks</li>
            <li>Secure auth and guarded routes</li>
          </ul>
        </div>
      </div>

      <div className="about-metrics">
        <div className="metric-card">
          <p className="metric-value">₹5</p>
          <p className="metric-label">Single unlock for gated features</p>
        </div>
        <div className="metric-card">
          <p className="metric-value">All-in-one</p>
          <p className="metric-label">AI, comms, files, and notifications</p>
        </div>
        <div className="metric-card">
          <p className="metric-value">Ready UI</p>
          <p className="metric-label">Pages, cards, and toasts pre-styled</p>
        </div>
      </div>

      <div className="about-feature-list">
        <div className="about-feature">
          <p className="about-label">SMS</p>
          <h4>Send & schedule</h4>
          <p className="muted">Paywall-aware sending with status banners and timezone-aware scheduling.</p>
        </div>
        <div className="about-feature">
          <p className="about-label">Calls</p>
          <h4>Voice + notes</h4>
          <p className="muted">Place calls with notes, plus scheduling hooks that mirror the dashboard flow.</p>
        </div>
        <div className="about-feature">
          <p className="about-label">AI</p>
          <h4>Speech & vision</h4>
          <p className="muted">Speech ↔ text, face detection, and image analysis bundled under the ₹5 AI suite.</p>
        </div>
      </div>
    </div>
    <Footer />
  </>
);

export default About;
